import React, { Component } from 'react';
import { View, TouchableOpacity, Image } from 'react-native';
import Actions from '../../RouteActions';
import moment from 'moment';

//styles
import { listElement } from '../../generalStyles';
import styles from './styles';

//components
import Text from '../../components/Text/Text';
import ArchivedStatusLabel from '../../screens/Tracker/components/ArchivedStatusLabel/ArchivedStatusLabel';
import InterviewStatusLabel from '../../screens/Tracker/components/InterviewStatusLabel/InterviewStatusLabel';
import IneligibleStatusLabel from '../../screens/Tracker/components/IneligibleStatusLabel/IneligibleStatusLabel';

//utils

//images
import defaultOrgAvatar from '../../assets/img/default_org_avatar.png';
import defaultUserAvatar from '../../assets/img/default_user_avatar.png';

//constants
import archivedStatuses from '../../constants/archivedStatuses';

//utils
import { normalizePrice } from '../../helperFunctions';

class TheirOpportunityElement extends Component {
    render() {
        const { opportunity, status } = this.props;
        const image = opportunity.logo_image_url ? { uri: opportunity.logo_image_url } : defaultOrgAvatar;
        const firstReferral = opportunity.referrals[0];
        if(!firstReferral) {
            return null;
        }

        const wrapperStyles = [listElement.elementWrapper, styles.newWrapperStyles];

        let avatar = defaultUserAvatar;
        let daysLeft = null;

        const detailsInfo = {
            jobId: opportunity.uuid,
            referralId: opportunity.referrals[0].uuid,
            requestId: opportunity.referrals[0].request_uuid,
            direction: 'their',
            status: status
        };
        const candidateStatus = firstReferral.candidate_status;

        if (firstReferral) {
            if (firstReferral.avatar_thumb) {
                avatar = { url: firstReferral.avatar_thumb }
            }

            daysLeft = moment(firstReferral.referral_expires_at).fromNow(true);

            if (firstReferral.candidate_status === 'offer') {
                wrapperStyles.push({ backgroundColor: '#f4db96' });
            }

            detailsInfo.candidateStatus = firstReferral.candidate_status;
        }

        return (
          <TouchableOpacity style={wrapperStyles} onPress={() => Actions.opportunityDetails(detailsInfo)}>
            <View style={listElement.imageWrapper}>
              <Image style={[listElement.image]} source={image} resizeMode="contain" />
            </View>
            <View style={[listElement.elementBody, styles.bodyStyles]}>
              <View style={listElement.infoWrapper}>
                {!firstReferral.reward_eligible && status != 'new' && <IneligibleStatusLabel />}
                <Text style={[listElement.title, listElement.bold]} numberOfLines={1}>
                  {firstReferral.full_name}
                </Text>
                <Text style={listElement.description} numberOfLines={1}>
                  {opportunity.title}
                </Text>
                <Text style={listElement.description} numberOfLines={1}>
                  {opportunity.organization_name}
                </Text>
                {candidateStatus === 'hired' && (
                  <Text style={[listElement.salary, styles.salaryStyleHired]}>
                    {!!opportunity.bounty_amount && `$ ${opportunity.bounty_amount}`}
                  </Text>
                )}
                {candidateStatus != 'hired' && (
                  <Text style={[listElement.salary, styles.salaryStyleNonHired]}>
                    {!!opportunity.bounty_amount && `$ ${opportunity.bounty_amount}`}
                  </Text>
                )}
                {archivedStatuses.indexOf(firstReferral.candidate_status) !== -1 && (
                  <ArchivedStatusLabel opportunity={opportunity} direction="their" />
                )}
                {firstReferral.candidate_status.includes('interview') && (
                  <InterviewStatusLabel opportunity={opportunity} direction="their" />
                )}
              </View>
              {firstReferral.candidate_status === 'new' && (
                <View style={listElement.rightBlock}>
                  <View style={[listElement.timestampWrapper, { paddingBottom: 60 }]}>
                    <Text style={listElement.timestampRed}>{daysLeft} left</Text>
                  </View>
                </View>
              )}
            </View>
          </TouchableOpacity>
        );
    }
}

export default TheirOpportunityElement;
